const Yup = require('yup');

export const requestFormSchema = () => {

	return Yup.object().shape({
		name: Yup.string()
			.when('$patch', { is: true, then: i => i.notRequired(), otherwise: i => i.required('Required') }).max(32),
		surname: Yup.string()
			.when('$patch', { is: true, then: i => i.notRequired(), otherwise: i => i.required('Required') }),
		email: Yup.string()
			.email('Must be an email')
			.when('$patch', { is: true, then: i => i.notRequired(), otherwise: i => i.required('Required') }),
		phone: Yup.string()
			.matches(/^[0-9]+$/, 'Must be only digits')
			.min(9, 'Phone number is not valid')
			.when('$patch', { is: true, then: i => i.notRequired(), otherwise: i => i.required('Required') }),
		address: Yup.string()
			.when('$patch', { is: true, then: i => i.notRequired(), otherwise: i => i.required('Required') }),
		birthday: Yup.date()
			.when('$patch', { is: true, then: i => i.notRequired(), otherwise: i => i.required('Required') }),
		selectedUniversity: Yup.string()
			.when('stayPurpose', { is: v => v === 'study', then: i => i.required('Required'), otherwise: i => i.notRequired() }),
		universityName: Yup.string()
			.when(['stayPurpose', 'selectedUniversity'], {
				is: (stayPurpose, selectedUniversity) => stayPurpose === 'study' && selectedUniversity === 'Other',
				then: Yup.string().required('Required'),
			}),
		studyYear: Yup.number()
			.integer('Incorrect format. Allowed symbols: 0-9')
			.when('stayPurpose', { is: v => v === 'study', then: i => i.required('Required'), otherwise: i => i.notRequired() }),
		gender: Yup.string()
			.when('$patch', { is: true, then: i => i.notRequired(), otherwise: i => i.required('Required') }),
		typeOfStudent: Yup.string()
			.when('stayPurpose', { is: v => v === 'study', then: i => i.required('Required'), otherwise: i => i.notRequired() }),
		faculty: Yup.string()
			.when(['stayPurpose', 'selectedFaculty'], {
				is: (stayPurpose, selectedFaculty) => stayPurpose === 'study' && selectedFaculty === 'Other',
				then: Yup.string().required('Required'),
			}),
		selectedFaculty: Yup.string()
			.when('stayPurpose', { is: v => v === 'study', then: i => i.required('Required'), otherwise: i => i.notRequired() }),
		stayPurpose: Yup.string()
			.when('$patch', { is: true, then: i => i.notRequired(), otherwise: i => i.required('Required') }),
		country: Yup.string().required('Required'),
	});
};
